<mat-sidenav-container
  class="sidenav-container"
  [style.--sidenav-width]="showCollapsed() ? '64px' : '260px'"
  [style.--content-margin]="isMobile() ? '0px' : (showCollapsed() ? '64px' : '260px')"
>
  <mat-sidenav
    [mode]="sidenavMode()"
    [opened]="sidenavOpen()"
    (openedChange)="sidenavOpen.set($event)"
    [class.collapsed]="showCollapsed()"
  >
    <app-sidebar [collapsed]="showCollapsed()" (expandRequest)="onSidebarExpandRequest()" />
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header (menuClick)="handleMenuClick()" />
    <main class="page-content">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
